import { styled } from '@mui/material';

const ContentWrapper = styled('div')({
  height: 260,
});

export default ContentWrapper;
